<template>

  <div class="supersummary" v-if="(builder.mode == 'build' && builder.step > 1) && builder.showSummary" @keydown.esc="close">
    <div class="supersummary-overlay" @click.stop="hideSummary"></div>
    <div class="supersummary-inner">

      <div class="supersummary-tabs">
        <button class="supersummary-tab" :class="{ 's_active' : tab == 'overview' }" @click="loadTab('overview')">Overview</button>
        <button class="supersummary-tab" :class="{ 's_active' : tab == 'design' }" @click="loadTab('design')" v-if="summaryComponent">Design</button>
        <button class="supersummary-tab l_close" @click="hideSummary">
          <svg class="icon"><use href="#cross"></use></svg>
        </button>
      </div>

      <div class="supersummary-main">

        <div class="supersummary-content" v-if="tab == 'overview'">
          <Overview
            @order-now="orderNow"
            @save-and-exit="saveAndExit">
          </Overview>
        </div>

        <div class="supersummary-content" v-if="tab == 'design' && summaryComponent">
          <component
            :is="summaryComponent"
            :always-open="true">
          </component>
        </div>

      </div>

      <button class="button l_base l_strong l_icon l_subtle-curves" @click="hideSummary">
        <span class="btn-text">Continue building</span>
        <svg class="icon btn-icon"><use href="#arrow-right"></use></svg>
      </button>

    </div>
  </div>

</template>

<script setup>

import { reactive, computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

// import wardrobesOverview from "@/components/builder/products/kitchens/kitchen/SectionsOverview.vue";
import kitchensOverview from "@/components/builder/products/kitchens/kitchen/SectionsOverview.vue";
import laundriesOverview from "@/components/builder/products/laundries/laundry/SectionsOverview.vue";

const comps = {
  // wardrobesOverview,
  kitchensOverview,
  laundriesOverview,
};

const summaryComponent = computed(() => {
  if (typeof comps[builder.range.handle + 'Overview'] !== undefined) return comps[builder.range.handle + 'Overview']
  return false;
})

const tab = ref('overview');

function loadTab(id) {
  tab.value = id;
}

function hideSummary() {
  builder.showSummary = false;
}

// const emit = defineEmits(['saveAndContinue'])

// const progressBarStatus = computed(() => {
//   return (builder.currentItem.percentage ?? 0) < 30 ? 'low' : 'high';
// })

// function gotoOverview() {
//   builder.scrollToRef('builderTop');
// }

// function gotoDesign() {
//   builder.scrollToRef('sectionsOverviewGroup');
// }

// function orderNow(e) {
//   if (!builder.isSubmitted) window.location = '/order/add/' + builder.quote.hash + '/';
//   e.preventDefault();
//   return false;
// }

// function saveAndContinue(e) {
//   emit('saveAndContinue', e);
// }
</script>
